import { Component, OnInit, TemplateRef } from '@angular/core';
import { Government } from './government';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GovernmentService } from './government.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-government',
  templateUrl: './government.component.html',
  styleUrls: ['./government.component.css']
})
export class GovernmentComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Government';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  governmentForm: FormGroup;
  governments: Government[] = [];
  governmentsactive: Government[] = [];
  government: Government;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  governmentModalRef: BsModalRef;
  operation: string;
  userid: number;
  governmentid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'government'; //set default
  reverse: boolean = false;

  constructor(
    private governmentservice: GovernmentService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Government_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Government_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Government_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Government_action');
    }
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.governmentForm = this.formBuilder.group({
      governmentid: [''],
      government: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedgovernment");
    let data = arrays.find(ob => ob['name'] === 'Government');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedgovernment","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedgovernment",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.governmentModalRef.hide();
  }

  getAll() {
    this.governments = [];
    this.governmentsactive = [];
    this.governmentservice.Get().subscribe(res => {
      this.governments = res;
      if (this.showallstatus == true) {
        this.governments.forEach(data => {
          if (data.active == 1) {
            this.governmentsactive.push(data);
          }
        });
        this.governments = [];
        this.governments = this.governmentsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.governmentsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.governments.forEach(data => {
        if (data.active == 1) {
          this.governmentsactive.push(data);
        }
      });
      this.governments = [];
      this.governments = this.governmentsactive;
    }
    else {
      this.showall = true;
      this.governments = [];
      this.getAll();
    }
  }

  get g() { return this.governmentForm.controls; }

  Post(government: Government) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.governmentForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.governmentForm.errors);
    //}
    if ((government.government.trim() == undefined) || (government.government.trim() == '')) {
      this.toastr.error('Government should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    government.government = government.government.trim();
    if (this.operation == 'add') {

      government.createdby = this.userid;
      msg = "Record Added Successfully";
      this.governmentservice.Post(government).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.governmentModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      government.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.governmentservice.Put(government).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.governmentModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.governmentForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.governmentForm.value.active = 1;
    } else {
      this.governmentForm.value.active = 0
    }
  }

  OpenConfirmTemplate(government, template: TemplateRef<any>) {
    if (government.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.government = government;

          this.Delete();

        }

      });

  }

  Delete() {
    var msg;
    if (this.government.active == 0) {
      this.government.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.government.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");

    this.government.modifiedby = this.userid;
    this.governmentservice.Delete(this.government).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.governmentModalRef.hide();
  }

  openGovernmentModal(template: TemplateRef<any>, type, government?: Government) {
    this.operation = type

    if (type == 'update') {
      this.governmentForm.controls['governmentid'].setValue(government.governmentid);
      this.governmentForm.controls['government'].setValue(government.government);
      this.governmentForm.controls['active'].setValue(government.active);
      this.government = government;
    }
    if (type == 'add') {
      this.governmentForm.controls['governmentid'].setValue(0);
      this.governmentForm.controls['government'].setValue('');
      this.governmentForm.controls['active'].setValue(1);
    }
    this.governmentModalRef = this.modalService.show(template, this.config);

    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

}
